import React, { useState } from 'react';
import './components/SongList.css'; // Reusing existing styles for consistency

const API_FEEDBACK = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/api/feedback` 
  : 'http://localhost:8000/api/feedback';

const FeedbackPage = ({ onBack, token }) => {
  const [type, setType] = useState('bug'); // bug, support, idea
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle'); // idle, sending, success, error
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMessage('');

    try {
      const res = await fetch(API_FEEDBACK, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify({
          type,
          subject,
          message,
          page: window.location.pathname,
          userAgent: navigator.userAgent
        })
      });

      if (res.ok) {
        setStatus('success');
        setSubject('');
        setMessage('');
      } else {
        const data = await res.json().catch(() => ({}));
        setErrorMessage(data.message || 'We could not send your report. Please try again.');
        setStatus('error');
      }
    } catch (err) {
      console.error(err);
      setErrorMessage('Connection error. Please check your internet connection and try again.');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="home-container" style={{textAlign:'center', marginTop:'50px'}}>
        <h2 style={{color:'#28a745'}}>Thank You!</h2>
        <p>Your report has been sent. Thanks for helping improve Octavepad.</p>
        <button className="btn-create-large" onClick={onBack} style={{marginTop:'20px'}}>Back to Home</button>
        <div style={{marginTop:'10px'}}>
           <span onClick={() => setStatus('idle')} style={{textDecoration:'underline', cursor:'pointer', color:'#666'}}>Send another?</span>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <div className="home-header">
        <button className="back-btn" onClick={onBack}>← Back</button>
        <h1>Bug Report & Support</h1>
      </div>

      <div className="login-card" style={{maxWidth: '600px', margin: '0 auto'}}>
        <form onSubmit={handleSubmit} className="login-form">
          
          {/* TYPE TOGGLE */}
          <div style={{display:'flex', gap:'10px', marginBottom:'15px'}}>
            {['bug', 'support', 'idea'].map(t => (
              <button
                key={t}
                type="button"
                onClick={() => setType(t)}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '6px',
                  border: type === t ? '2px solid #007bff' : '1px solid #ddd',
                  background: type === t ? '#e7f1ff' : 'white',
                  fontWeight: type === t ? 'bold' : 'normal',
                  cursor: 'pointer',
                  textTransform: 'capitalize'
                }}
              >
                {t}
              </button>
            ))}
          </div>

          <label className="tool-label">Subject</label>
          <input 
            className="tool-input" 
            placeholder={type === 'bug' ? "e.g. Save button isn't working" : type === 'support' ? "e.g. I need help with my account" : "e.g. Add dark mode"}
            value={subject}
            onChange={e => setSubject(e.target.value)}
            maxLength={120}
            required
          />

          <label className="tool-label" style={{marginTop:'15px'}}>Message</label>
          <textarea 
            className="tool-input" 
            style={{minHeight: '150px', resize:'vertical'}}
            placeholder="Tell us what happened, what you expected, and any steps that reproduce it."
            value={message}
            onChange={e => setMessage(e.target.value)}
            maxLength={3000}
            required
          />

          {status === 'error' && <div className="error-msg">{errorMessage}</div>}

          <button type="submit" className="btn-create-large" style={{width:'100%', borderRadius:'8px'}} disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending...' : 'Send Report'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackPage;
